import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'results'];

  connect() {
    this.timeout = null;
    this.membershipPeriodId = this.element.dataset.membershipPeriodId; // データ属性から取得
  }

  performSearch() {
    if (!this.hasResultsTarget) {
      console.error('Error: Missing target element \'results\' for \'search\' controller');
      return; // `results` ターゲットがない場合は処理を中断
    }

    clearTimeout(this.timeout); // 直前のタイマーをクリア
    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value;
      const email = document.querySelector('#search_email').value;
      const customer_id = document.querySelector('#search_id').value;
      const url = `/benefit_one/membership_periods/${this.membershipPeriodId}/members/search?query=${query}&email=${email}&customer_id=${customer_id}`;

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((response) => response.text())
        .then((html) => {
          if (this.hasResultsTarget) {
            this.resultsTarget.innerHTML = html; // 結果を更新
          } else {
            console.warn('検索結果のターゲットが見つかりませんでした');
          }
        })
        .catch(error => console.error('検索リクエストエラー:', error));
    }, 300); // 300ms の遅延
  }
}
